// the latest version of the widget
export const VERSION = 2;

class UpgradeV2 {
  version = 2;
  upgrade(widget: any) {
    // recursively remove marks from the prosemirror data
    function removeMark(obj: any, markType: string) {
      if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; i++) {
          removeMark(obj[i], markType);
        }
      } else if (typeof obj === 'object') {
        for (const key in obj) {
          // filter out marks of the given type from the node marks array
          if (key === 'marks' && Array.isArray(obj[key])) {
            obj[key] = obj[key].filter((mark: any) => mark?.type !== markType);
          } else {
            // recursively check child nodes
            removeMark(obj[key], markType);
          }
        }
      }
    }

    // remove deprecated marks
    removeMark(widget.proseMirrorData, 'strike');
    removeMark(widget.proseMirrorData, 'code');

    // recursively remove deprecated nodes without removing their content nodes
    function liftOutNode(obj: any, type: string) {
      // content is an array of nodes
      if (Array.isArray(obj)) {
        processContentArray(obj, type);
        // a node itself
      } else if (typeof obj === 'object') {
        for (const key in obj) {
          liftOutNode(obj[key], type);
        }
      }
    }
    function processContentArray(contentArray: any, type: string) {
      for (let i = 0; i < contentArray.length; i++) {
        if (contentArray[i].type === type) {
          const nodeContent = contentArray[i].content;
          contentArray.splice(i, 1, ...nodeContent);
          i += nodeContent.length - 1;
          processContentArray(nodeContent, type);
        } else {
          liftOutNode(contentArray[i], type);
        }
      }
    }

    // remove deprecated nodes
    // (99% of text widgets won't have these nodes as they can only be created through shortcuts / regex parsing)
    liftOutNode(widget.proseMirrorData, 'blockquote');
    liftOutNode(widget.proseMirrorData, 'codeBlock');
  }
}

// Add VersionControllers here that implement the WidgetVersionController interface
export const tableWidgetVersionControllers = [new UpgradeV2()];
